// === ApplicationFormPage.js (The Traffic Cop) ===
import React from 'react';
import { tenantConfig } from '../../config/tenantConfig';
import ApplicationFormUniversal from './ApplicationFormUniversal';

// We will create this file in the next step!
import ApplicationFormJBMarks from '../../components/tenants/jbmarks/ApplicationFormJBMarks'; 

const ApplicationFormPage = () => {
    // 🚨 Check the config: Is this deployment for JB Marks?
    if (tenantConfig.id === 'JBMARKS') {
        // Return the custom JB Marks application form
        return <ApplicationFormJBMarks />;
    }

    // Default: Load the standard BrightSparc form
    return <ApplicationFormUniversal />;
};

export default ApplicationFormPage;